import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  SetStateAction,
  Dispatch,
  useEffect,
} from 'react';
import { isValid } from 'date-fns';
import { MonthSelector, Calendar } from './components';
import { Container } from './styled';
import { useDateTimePicker } from '../..';

type DateSelectionContextType = {
  activeDate: Date;
  setActiveDate: Dispatch<SetStateAction<Date>>;
};

const DateSelectionContext = createContext<
  DateSelectionContextType | undefined
>(undefined);

export const useDateSelection = () => {
  const context = useContext(DateSelectionContext);

  if (!context)
    throw new Error('useDateSelection can only be used inside DateSelection');

  return context;
};

export const DateSelection = () => {
  const { selectedValue, t } = useDateTimePicker();

  const [activeDate, setActiveDate] = useState(selectedValue);

  useEffect(() => {
    if (isValid(selectedValue)) {
      setActiveDate(selectedValue);
    }
  }, [selectedValue]);

  const value = useMemo(
    () => ({
      activeDate,
      setActiveDate,
    }),
    [activeDate, setActiveDate],
  );

  return (
    <Container>
      <DateSelectionContext.Provider value={value}>
        <MonthSelector t={t} />
        <Calendar />
      </DateSelectionContext.Provider>
    </Container>
  );
};
